<template>
  <div class="main-content">
    <a-t-loader v-if="isLoadingAllBanks" />

    <template v-else>
      <div class="page-content">
        <div class="container">
          <section class="banks-block">
            <div class="page-title-header">
              <h2>Bank Settings</h2>
              <div
                @click="openModalBanks('new', templateNewBank)"
                class="btn btn--green">
                <span>Add Bank</span>
              </div>
            </div>
            <div class="page-title">
              <h2>All Banks</h2>
            </div>

            <div class="banks-list">
              <div class="banks-list_header">
                <div class="header-title">
                  <span>Bank of Beneficiary</span>
                </div>
                <div class="header-title">
                  <span>Beneficiary</span>
                </div>
              </div>
              <div class="banks-list_body">
                <div
                  v-for="(bank, index) in allBanks"
                  :key="bank.id"
                  class="bank-item">
                  <div class="bank-item_number">
                    <span>{{ index + 1 }}.</span>
                  </div>
                  <div class="bank-item_content">
                    <div class="content-block_top">
                      <div class="content-block">
                        <div class="content-block_name">
                          <span class="content-block_name-bank"
                            >Bank Name:
                          </span>
                          <span class="content-block_name-bank">{{
                            bank.name
                          }}</span>
                        </div>
                        <div class="content-block_name">
                          <span>Short Bank Name:</span>
                          <span>{{ bank.shortName }}</span>
                        </div>
                        <div class="content-block_name">
                          <span>SWIFT:</span>
                          <span>{{ bank.swift }}</span>
                        </div>
                        <div class="content-block_name">
                          <span>Bank Address:</span>
                          <span>{{ bank.bankAddress }}</span>
                        </div>
                      </div>
                      <div class="content-block">
                        <div class="content-block_name">
                          <span>IBAN Account:</span>
                          <span>{{ bank.ibanAccount }}</span>
                        </div>
                        <div class="content-block_name">
                          <span>Company Name: </span>
                          <span>{{ bank.companyName }}</span>
                        </div>
                        <div class="content-block_name">
                          <span>Company Address: </span>
                          <span>{{ bank.beneficiaryAddress }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="bank-item_options">
                    <button
                      type="button"
                      class="btn form-control-action"
                      @click="openModalBanks('edit', bank)">
                      <span class="form-control-action__icon icon--green">
                        <svg width="1em" height="1em" class="icon icon-edit">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                        </svg>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </template>

    <a-t-modal-banks
      v-if="isModalBank"
      :currentBank="currentBank"
      @closeModalBankParameters="closeModalBank"
      @changeBankParameters="changeBank"
    />
  </div>
</template>

<script>
import Vuex from 'vuex'
import ATLoader from '@/components/Loaders/Loader'
import {
  actionTypes as actionTypesBanks,
  getterTypes as getterTypesBanks,
} from '@/store/modules/banks'
import ATModalBanks from '@/components/Modals/ModalBankSettings'
export default {
  name: 'ATBanks',
  data() {
    return {
      isModalBank: false,
      currentBank: {},
      templateNewBank: {
        name: '',
        shortName: '',
        swift: '',
        bankAddress: '',
        ibanAccount: '',
        companyName: '',
        beneficiaryAddress: '',
        priority: 10,
        publicInvoices: true,
        contractType: 'TZ',
        availableCurrencies: [],
      },
    }
  },
  components: {ATModalBanks, ATLoader},
  computed: {
    ...Vuex.mapGetters({
      allBanks: getterTypesBanks.allBanks,
      isLoadingAllBanks: getterTypesBanks.isLoadingAllBanks,
    }),
  },
  methods: {
    ...Vuex.mapActions({
      findBanks: actionTypesBanks.findBanks,
      createdBank: actionTypesBanks.createdBank,
      updatedBank: actionTypesBanks.updatedBank,
    }),
    closeModalBank(value) {
      this.isModalBank = value
    },
    findAllBanks() {
      this.findBanks()
    },
    openModalBanks(flag, bank) {
      this.isModalBank = true
      this.currentBank = {
        ...bank,
        type: flag,
        availableCurrencies: Array.isArray(bank.availableCurrencies)
          ? [...bank.availableCurrencies]
          : [],
      }
    },
    changeBank(bank) {
      if (bank.type === 'new') this.createdBank(bank).then(() => this.findAllBanks())
      if (bank.type === 'edit') this.updatedBank(bank).then(() => this.findAllBanks())
    }
  },
  mounted() {
    this.findAllBanks()
  },
}
</script>
